import React, { RefObject } from 'react';
import { Input as BaseUIInput, InputProps } from 'baseui/input';

import { TechemTheme } from '@techem/techem-theme';

interface CustomInputProps extends InputProps {
  inputRef?: RefObject<HTMLInputElement>; // need to be referenced if auto-focus hook is used
  additionalTestId?: string;
  inputStyleOverrides?: any;
  rootStyleOverrides?: any;
}

const Input = (props: Omit<CustomInputProps, '$theme'>) => {
  return (
    <BaseUIInput
      overrides={{
        Root: {
          style: {
            ...props.rootStyleOverrides
          }
        },
        Input: {
          props: {
            'data-gi': `${props.additionalTestId !== undefined ? ' ' + props.additionalTestId : ''}`
          },
          style: {
            color: TechemTheme.colors.contentSecondary,
            ...props.inputStyleOverrides
          }
        }
      }}
      {...props}
    />
  );
};
export default Input;
